import { http } from '@/api/http';
import { saveFile } from '@/lib/share';

/** Имя файла из Content-Disposition: `filename*=UTF-8''…` (кириллица) или `filename="…"`. */
export function filenameFrom(header: unknown): string | null {
  if (typeof header !== 'string') return null;
  const star = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1]);
    } catch {
      // битое кодирование — попробуем простое имя
    }
  }
  const plain = /filename="([^"]+)"/i.exec(header);
  return plain?.[1] ?? null;
}

/**
 * Скачать файл с сервера через общий HTTP-клиент: в десктопном клиенте ссылка `/api/...`
 * указывала бы внутрь программы, а не на сервер, и cookie входа живут в программе.
 */
export async function downloadFile(url: string, fallbackName: string): Promise<void> {
  saveFile(await fetchFile(url, fallbackName));
}

/** Файл с сервера целиком, с именем из Content-Disposition — например, для «Поделиться». */
export async function fetchFile(url: string, fallbackName: string): Promise<File> {
  const res = await http.request<Blob>({ method: 'GET', url, responseType: 'blob' });
  const name = filenameFrom(res.headers['content-disposition']) ?? fallbackName;
  return new File([res.data], name, { type: res.data.type });
}
